var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaign
    ? _c(
        "div",
        { staticClass: "page" },
        [
          _c("div", { staticClass: "page-main" }, [
            _c("div", { staticClass: "page-header" }, [
              _c(
                "div",
                {
                  staticClass:
                    "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
                },
                [
                  _c("h1", { staticClass: "page-title" }, [_vm._v("Campaign")]),
                  _c("breadcrumb", {
                    attrs: {
                      name: "PROGRESS_BAR_CAMPAIGN_EDIT",
                      withLast: _vm.campaign.name,
                    },
                    on: {
                      "update:withLast": function ($event) {
                        return _vm.$set(_vm.campaign, "name", $event)
                      },
                      "update:with-last": function ($event) {
                        return _vm.$set(_vm.campaign, "name", $event)
                      },
                    },
                  }),
                  _c("div", { staticClass: "page-title page-header-actions" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-round btn-primary mx-10",
                        attrs: { type: "button", disabled: !_vm.canPreview },
                        on: { click: _vm.openPreviewModal },
                      },
                      [_vm._v(" Preview ")]
                    ),
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-round btn-default mx-10",
                        attrs: { type: "button" },
                        on: { click: _vm.goBack },
                      },
                      [
                        _c("i", {
                          staticClass: "icon md-chevron-left",
                          attrs: { "aria-hidden": "true" },
                        }),
                        _vm._v(" Back "),
                      ]
                    ),
                  ]),
                ],
                1
              ),
            ]),
            _c("div", { staticClass: "page-content container-fluid" }, [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  {
                    staticClass:
                      "col-md-12 col-lg-12 col-xl-12 col-xxl-10 offset-xxl-1",
                  },
                  [
                    _c("div", { staticClass: "panel panel-bordered" }, [
                      _c("div", { staticClass: "panel-heading pt-5" }, [
                        _c(
                          "div",
                          { staticClass: "panel-title campaign-type-group" },
                          [
                            _c("h4", { staticClass: "my-0" }, [
                              _vm._v(
                                "Campaign Information - " +
                                  _vm._s(_vm.campaign.id)
                              ),
                            ]),
                            _c("p", { staticClass: "my-0" }, [
                              _vm._v(
                                " User Type: " +
                                  _vm._s(
                                    _vm._f("progressbarUserType")(
                                      _vm.campaign.user_type
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                        _c("div", {
                          staticClass: "panel-actions panel-actions-keep",
                        }),
                        _c(
                          "div",
                          { staticClass: "panel-title campaign-type-group" },
                          [
                            _c("p", [
                              _vm._v(_vm._s(_vm._f("toUpperCase")(_vm.type))),
                            ]),
                            _c("p", [
                              _vm._v(
                                " User Group: " +
                                  _vm._s(
                                    _vm.campaign.user_type === "contact_id"
                                      ? _vm.campaign.group.group_code
                                      : "-"
                                  ) +
                                  " "
                              ),
                            ]),
                          ]
                        ),
                      ]),
                      _c("div", { staticClass: "panel-body" }, [
                        _vm.campaign.type == "barcode"
                          ? _c(
                              "div",
                              [
                                _c("BarcodeForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.campaign.type == "team"
                          ? _c(
                              "div",
                              [
                                _c("TeamForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.campaign.type == "monthly"
                          ? _c(
                              "div",
                              [
                                _c("MonthlyForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.campaign.type == "monthlyshort"
                          ? _c(
                              "div",
                              [
                                _c("MonthlyShortForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.campaign.type == "task"
                          ? _c(
                              "div",
                              [
                                _c("TaskForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                                _c("hr"),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.campaign.type == "leaderboard"
                          ? _c(
                              "div",
                              [
                                _c("LeaderBoardForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.campaign.type == "stamp"
                          ? _c(
                              "div",
                              [
                                _c("StampForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.campaign.type == "weekly"
                          ? _c(
                              "div",
                              [
                                _c("WeeklyForm", {
                                  attrs: { campaign: _vm.campaign },
                                  on: { updated: _vm.fetchCampaign },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                      _vm._m(0),
                    ]),
                  ]
                ),
              ]),
            ]),
          ]),
          _c(
            "modal",
            {
              attrs: {
                name: "preview-campaign-modal",
                width: 400,
                height: "auto",
              },
            },
            [_c("PreviewPopup", { attrs: { campaign: _vm.campaign } })],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "panel-footer" }, [
      _c("div", { staticClass: "d-flex justify-content-between" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }